import * as Sentry from '@sentry/browser'

const configEl = document.getElementById('sentry-config')
const config = configEl ? JSON.parse(configEl.textContent) : {}

if (config.dsn) {
  Sentry.init({
    dsn: config.dsn,
    environment: config.environment || 'unknown',
    release: config.release || undefined,
  })
}

window.Sentry = Sentry
